import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const ASPHALT = "#3f4044";
const MARKING = "#e8e6e0";

export const crosswalkTile = defineModel({
  id: "crosswalk-tile",
  batchId: "modern",
  name: "Crosswalk tile",
  tags: ["modern", "outdoor", "ground", "street", "road", "asphalt", "crosswalk"],
  summary: "An asphalt tile with white zebra bars along X.",
  description:
    "A one-tile pedestrian crossing of the Modern Living kit: a 1x1 m " +
    "asphalt slab (0.06 m thick) with white zebra bars running along X, so " +
    "pedestrians cross along X over a road that runs along Z. Tiles " +
    "seamlessly with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    const bars: Part[] = [];
    // Five zebra bars, long axis along X, spaced along Z.
    for (let i = 0; i < 5; i++) {
      bars.push({
        geometry: new THREE.BoxGeometry(0.84, 0.012, 0.12),
        color: MARKING,
        position: [0, 0.06, -0.32 + i * 0.16],
      });
    }
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: ASPHALT, position: [0, 0.03, 0] },
      ...bars,
    ];
  },
  animations: [],
});
